module.exports = __webpack_public_path__ + "img/bg-magento-find-out_medium.03e5ce01.webp";